import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lib',
  templateUrl: './lib.component.html',
  styleUrls: ['./lib.component.css']
})
export class LibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
